import { CitationSVG, Icon, useModal } from "@newsela/angelou";
import { actionNames } from "@newsela/snitch";

import { ContentLevel } from "@/types/models/ContentLevel.interface";
import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton";

import { IContentData } from "./CitationAction.interface";
import { iconCss } from "./CitationAction.style";
import CitationModal from "./CitationModal";

interface CitationActionProps {
  currentLevel: ContentLevel | undefined;
  disabled: boolean;
  hoverLabel: string;
  contentData?: IContentData | undefined;
}
export const CitationAction = ({
  contentData,
  currentLevel,
  disabled,
  hoverLabel,
}: CitationActionProps) => {
  const [modalProps, setActive, triggerRef] = useModal(false);
  const icon = <Icon __cssFor={{ root: iconCss }} SvgComponent={CitationSVG} />;

  const ariaProps = { "aria-label": "Citation" };

  const eventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName: actionNames.start,
    streamProperties: {
      content_type: "Citation",
      description: "Open Citation pop-up",
    },
  };

  return contentData ? (
    <>
      <SecondaryActionButton
        ariaProps={ariaProps}
        buttonRef={triggerRef}
        dataProps={{ "data-qa-selector": "show-citation" }}
        disabled={disabled}
        eventProperties={eventProperties}
        hoverLabel={hoverLabel}
        icon={icon}
        onClick={() => setActive(true)}
        title="Citation"
      />
      <CitationModal
        contentData={contentData}
        currentLevel={currentLevel}
        modalProps={modalProps}
        setActive={setActive}
      />
    </>
  ) : (
    <></>
  );
};

export default CitationAction;
